import Cookie from '@wetransfer/concorde-cookie';

import { AppConfig } from '@app/core-bundle/config/app-config';

import { getCookieDomain } from '@helper/cookies';

import Analytics from '@module/analytics';

export const defaultSettings = {
  id: AppConfig.privacy.consentId,
  version: AppConfig.privacy.consentVersion,
  name: AppConfig.cookies.privacy.name,
  durationInDays: 365,
  init: true,
  domain: getCookieDomain(),
};

// Module state
let settings = {
  ...defaultSettings,
  validVersion: `${defaultSettings.id}:${defaultSettings.version}`,
};

const Privacy = {
  settings,

  configure,

  acceptTrackers,
  declineTrackers,

  userAllowsTracking,
  userHasClosedBanner,
};

/**
 * Configure Terms And Conditions
 * @param    {Object}   [opts=defaultSettings]       Configuration
 * @property {Boolean}  [opts.name]                  Cookie name
 * @property {Number}   [opts.durationInDays]        Cookie expiration
 * @property {String}   [opts.domain=wetransfer.com] The platform domain
 */
function configure(opts = {}) {
  settings = {
    ...settings,
    ...opts,
  };

  if (userAllowsTracking()) {
    track({ allowTracking: true });
  } else if (!settings.init) {
    // We don't sent this out on start up
    track({ allowTracking: false });
  }

  settings.init = false;
}

/**
 * Accept third party trackers
 */
function acceptTrackers() {
  setCookie({ allowTracking: true });
  track({ allowTracking: true });
}

/**
 * Decline third party trackers
 */
function declineTrackers() {
  setCookie({ allowTracking: false });
  track({ allowTracking: false });
}

function userAllowsTracking() {
  const cookie = getCookie();

  return (
    cookie !== null &&
    cookie !== undefined &&
    cookie.version === settings.validVersion &&
    cookie.allowTracking === 1
  );
}

function userHasClosedBanner() {
  const cookie = getCookie();

  return (
    cookie !== null &&
    cookie !== undefined &&
    cookie.version === settings.validVersion
  );
}

function track({ allowTracking = false }) {
  Analytics.configure({ allowTracking });

  // Snowplow
  Analytics.trackSnowplowEvent({
    category: 'cookie_wall',
    action: allowTracking ? 'accept_trackers' : 'decline_trackers',
  });

  // GTM
  Analytics.trackGoogleEvent({
    event: allowTracking ? 'trackingAccepted' : 'trackingDeclined',
    virtualPagePath: `${location.pathname}${location.search}`,
    virtualPageLocation: `${location}`,
  });
}

function setCookie({
  allowFunctional = true,
  allowAnalytical = true,
  allowTracking = false,
}) {
  Cookie.set(
    settings.name,
    JSON.stringify({
      v: settings.validVersion, // version
      f: allowFunctional ? 1 : 0, // allow functional
      a: allowAnalytical ? 1 : 0, // allow analytical
      t: allowTracking ? 1 : 0, // allow tracking
    }),
    {
      days: settings.durationInDays,
      domain: settings.domain,
    }
  );
}

function getCookie() {
  let cookie = null;
  try {
    cookie = Cookie.get(settings.name);
    cookie = JSON.parse(cookie);
    cookie = {
      version: cookie.v || '',
      allowFunctional: cookie.f || true,
      allowAnalytical: cookie.a || true,
      allowTracking: cookie.t || false,
    };
  } catch (error) {
    cookie = null;
  }
  return cookie;
}

export default Privacy;
